import { render } from "./CanvasInput.vue?vue&type=template&id=64ec639c&scoped=true"
import script from "./CanvasInput.vue?vue&type=script&lang=js"
export * from "./CanvasInput.vue?vue&type=script&lang=js"

import "./CanvasInput.vue?vue&type=style&index=0&id=64ec639c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ec639c"]])

export default __exports__